import styled from "styled-components";

import { getOpacityColor, grayScale } from "@enkor/design/colors";
import BaseBottomSheet from "@domains/common/views/modal/BaseBottomSheet/BaseBottomSheet";

export const BottomSheetContainer = styled(BaseBottomSheet)`
  width: 100%;
  height: fit-content;
  min-height: 104px;
  padding: 24px 0;
  border: 1px solid ${grayScale.main};
  border-radius: 16px 16px 0px 0px;

  background-color: ${grayScale[300]};
`;

export const MenuList = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;

  width: 100%;
  padding: 16px 24px;

  cursor: pointer;

  transition: all 0.3s ease-in-out;

  &:hover {
    background: ${getOpacityColor(grayScale.white, 0.1)};
  }
`;
